import { emitJourneyEvent, JOURNEY_STEP_TYPES } from "../../utils/journeyMonitoring";

/**
 * Emits a `user.milestone` journey-monitoring event for a benefits-related
 * step (search attempted/searched, found, not found). Scoped to
 * `commonBenefitsSaga`, so each call site in `commonBenefits`/`benefits` reads
 * as a single, self-describing line instead of repeating the same
 * `emitJourneyEvent(JOURNEY_STEP_TYPES.USER_MILESTONE, stepName, { milestoneName: stepName, ... })`
 * boilerplate. `milestoneName` is always set to `stepName` automatically.
 *
 * @param stepName - e.g. "benefits.searched", "benefits.found", "benefits.not_found"
 * @param metadata - additional event-specific metadata (e.g. attempt, reason, partnerCode)
 */
export const emitBenefitsJourneyEvent = (stepName: string, metadata: Record<string, any> = {}): void => {
  emitJourneyEvent(JOURNEY_STEP_TYPES.USER_MILESTONE, stepName, {
    milestoneName: stepName,
    ...metadata,
  });
};
